/* eslint-disable no-new-wrappers */
import {atom, selector} from 'recoil';

export const colors = atom({
  key: 'colors',
  default: [],
});

export const favoriteColors = atom({
  key: 'favoriteColors',
  default: null,
});

export const colorSeries = atom({
  key: 'colorSeries',
  default: null,
});

export const colorBrands = atom({
  key: 'colorBrands',
  default: null,
});

export const colorTons = atom({
  key: 'colorTons',
  default: null,
});

export const colorProperties = atom({
  key: 'colorProperties',
  default: null,
});

export const colorSuppliers = atom({
  key: 'colorSuppliers',
  default: null,
});

export const searchQuery = atom({
  key: 'searchQuery',
  default: '',
});

export const currentPage = atom({
  key: 'currentPage',
  default: 1,
});

export const chosenColorsArray = atom({
  key: 'chosenColors',
  default: [],
});

export const chosenColorsFilters = atom({
  key: 'chosenColorsFilters',
  default: [],
});

export const colorsSorting = atom({
  key: 'colorsSorting',
  default: null,
});

export const colorsFiltered = selector({
  key: 'colorsFiltered',
  get: ({get}) => {
    const search = get(searchQuery);
    const colorsData: any = get(colors);
    const allFavoriteColors = get(favoriteColors) || [];
    const allFavIds = allFavoriteColors.map((c: any) => c.id);
    const chosenFilters = get(chosenColorsFilters);
    const chosenBrands: any = [];
    chosenFilters.map((el: any) => {
      if (el.type === 'brands') {
        chosenBrands.push(el.label);
      }
    });
    const filteredBySearch = colorsData?.filter((c: any) =>
      c.name.toLowerCase().includes(search.toLowerCase()) &&
      !allFavIds.includes(c.id) && (chosenBrands.length > 0 ? chosenBrands.includes(c.brand) : true));
    return filteredBySearch;
  },
});
